import { Get, Post, apiEnv, GetAddress, GetStage, GetReturn, PostStage, GetPincodeFromMID, PostCenter } from 'api';
import { IYearlyCashbackApiData } from 'Slices/YearlyCashbackDetails';
import { API_URL } from './CONSTANT';
import { ISampleResponse, IGetParams, ObStatus, INewResponse } from 'types';
import { getURLParameter } from 'utils/nativeSupport';
import { loadState } from 'utils/LocalStorage';
import { TOKEN_SESSION_KEY } from 'utils/CONSTANT';

const sourceProduct = getURLParameter(window.location.href, 'sourceProduct') || 'SWIPE';

export const SampleAPI = async (): Promise<ISampleResponse> => Get<ISampleResponse>(API_URL.sampleUrl);

export const CheckForClubMembershipAPI = async (payload: any): Promise<ISampleResponse> =>
	Post<ISampleResponse>(apiEnv.BP_CLUB_BASE_PATH + API_URL.clubMemberApi, payload);

export const FetchClubV2MembershipAPI = async (payload: any): Promise<ISampleResponse> =>
	Get<ISampleResponse>(apiEnv.BP_CLUB_BASE_PATH + API_URL.clubV2Api, payload);

export const GetSwipePaymentPlansAPI = async (params: IGetParams): Promise<ISampleResponse> => {
	return Get<ISampleResponse>(API_URL.swipePaymentPlansV2, params);
};

export const GetSwipeOldPaymentPlansAPI = async (params: IGetParams): Promise<ISampleResponse> =>
	Get<ISampleResponse>(API_URL.swipeOldPaymentPlans, params);

export const GetPlanDetailsFromSerial = async (payload: any): Promise<ISampleResponse> =>
	Post<ISampleResponse>(API_URL.fetchPlanChargesFromSerial, payload);

export const GetAutheticateAPI = async (): Promise<ISampleResponse> => Get<ISampleResponse>(API_URL.authenticate);

export const GetAddressAPI = async (): Promise<ISampleResponse> =>
	Get<ISampleResponse>(apiEnv.MERCHANT_BASE_PATH + API_URL.getAddress);

export const GetApplicationAPI = async (params: IGetParams): Promise<ISampleResponse> =>
	Get<ISampleResponse>(API_URL.application, params);

export const FetchTransactionListSwipeAPI = async (params: IGetParams): Promise<ISampleResponse> =>
	Get<ISampleResponse>(API_URL.fetchTxnList, params);

export const FetchTransactionDetailsSwipeAPI = async (params: IGetParams): Promise<ISampleResponse> =>
	Get<ISampleResponse>(`${API_URL.fetchTxnDetails}${params.txnId}`, params);

export const TogglePrintQrAPI = async (payload: any): Promise<any> =>
	Post<any>(`${API_URL.togglePrintQr}${payload.checked}?bharat_swipe_terminal_id=${payload.terminalID}`, {});

export const initiateSwipePaymentAPI = async (payload: any): Promise<ISampleResponse> => {
	return Post<ISampleResponse>(API_URL.initiatePaymentV2, payload);
};

export const createApplicationAPI = async (payload: any): Promise<ISampleResponse> => {
	return Post<ISampleResponse>(API_URL.createApplicationV2, payload);
};

export const GetPaymentStatusAPI = async (params: IGetParams): Promise<ISampleResponse> =>
	Get<ISampleResponse>(`${API_URL.checkPaymentStatus}`, params);

export const CheckOglAPI = async (params: IGetParams): Promise<ISampleResponse> => {
	return Get<ISampleResponse>(`${API_URL.checkOGLV2}`, params);
};

export const CheckIfAddressInVicinityAPI = async (params: IGetParams): Promise<ISampleResponse> => {
	return Get<ISampleResponse>(`${API_URL.checkIfAddressInVicinity}`, params);
};

export const OpenKycTaskWithNewAddressAPI = async (payload: any): Promise<ISampleResponse> => {
	return Post<ISampleResponse>(`${API_URL.openKycTaskWithNewAddress}`, payload);
};

export const GetKYCstatusAPI = async (): Promise<ISampleResponse> => {
	return Get<ISampleResponse>(`${API_URL.kycStatusV2}`);
};

export const FetchMerchantInfo = async (payload: any): Promise<ISampleResponse> => {
	const { headers } = payload;
	return Get<ISampleResponse>(apiEnv.MERCHANT_BASE_PATH + API_URL.merchantInfo, {}, headers);
};

export const initiateKYC = async (payload: any): Promise<ISampleResponse> => {
	return Post<ISampleResponse>(API_URL.initiateKYCV2, payload);
};

export const FetchSettlementHistoryCsv = async (): Promise<ISampleResponse> => GetAddress(API_URL.settlementCsv);

export const FetchWidgetsAPI = async (params: IGetParams): Promise<ISampleResponse> =>
	Get<ISampleResponse>(`${API_URL.getWidgets}`, params);

export const FetchFaqsFromMerchantAPI = async (params: IGetParams): Promise<ISampleResponse> =>
	GetAddress(`${API_URL.getFaqsMerchant}`, params);

export const FetchMerchantDeviceList = async (params: IGetParams): Promise<ISampleResponse> =>
	Get<ISampleResponse>(`${API_URL.getMerchantDetailsList}`, params);

export const FetchActiveMachineCount = async (): Promise<ISampleResponse> => {
	return Get<ISampleResponse>(`${API_URL.getActiveMachineCountV2}`);
};

export const FetchPendingApplication = async (params: IGetParams): Promise<ISampleResponse> => {
	return Get<ISampleResponse>(`${API_URL.getPendingApplicationV2}`, params);
};

export const FetchMerchantReturnList = async (params: IGetParams): Promise<ISampleResponse> =>
	GetReturn<ISampleResponse>(`${API_URL.getDeviceReturnList}`, params);

export const FetchMerchantDeviceReturnStatus = async (params: IGetParams): Promise<ISampleResponse> =>
	GetReturn<ISampleResponse>(`${API_URL.getDeviceReturnStatusList}`, params);

export const CreateReturnRequest = async (payload: any): Promise<ISampleResponse> =>
	Post<ISampleResponse>(API_URL.createReturnRequest, payload);

export const CancelReturnRequest = async (payload: any): Promise<ISampleResponse> =>
	Post<ISampleResponse>(API_URL.cancelReturnRequest, payload);

export const FetchReturnRefundDetails = async (payload: any): Promise<ISampleResponse> =>
	Get<ISampleResponse>(`${API_URL.returnRefundDetails}`, payload);

export const FetchOverdueTxnList = async (): Promise<ISampleResponse> => GetAddress(API_URL.fetchOverdueList);

export const GetDeterminePlanFlow = async (params: IGetParams): Promise<ISampleResponse> =>
	Get<ISampleResponse>(API_URL.fetchDeterminePlanFlow, params);

export const SetTpvRanking = async (payload: any): Promise<ISampleResponse> =>
	Post<ISampleResponse>(API_URL.setTpvRanking, payload);

export const GetMdrCharges = async (params: IGetParams): Promise<ISampleResponse> =>
	Get<ISampleResponse>(API_URL.getMdrCharges, params);

export const GetCurrentMdrCharges = async (params: IGetParams): Promise<ISampleResponse> =>
	GetReturn<ISampleResponse>(API_URL.getCurrentMdrCharges, params);

export const GetPincodeFromMerchantId = async (params: IGetParams): Promise<ISampleResponse> =>
	GetPincodeFromMID<ISampleResponse>(`${API_URL.getPincodeFromMerchantId}`);

export const GetRentalCashbackWaiver = async (params: IGetParams): Promise<ISampleResponse> =>
	Get<ISampleResponse>(API_URL.getRentalCashbackWaiver, params);

export const GetDeliveryOrderDetails = async (params: IGetParams): Promise<ISampleResponse> =>
	Get<ISampleResponse>(API_URL.deliveryOrderDetails, params);

export const GetMigrationStatus = async (params: IGetParams): Promise<ISampleResponse> =>
	Get<ISampleResponse>(API_URL.getMigrationStatus, params);

export const UpdateMerchantResponseMdrMigration = async (payload: any): Promise<ISampleResponse> =>
	Post<ISampleResponse>(API_URL.merchantResponseMdrMigration, payload);

export const CreateMachineOrderCancelRequest = async (payload: any): Promise<ISampleResponse> =>
	Post<ISampleResponse>(API_URL.createMachineOrderCancelRequest, payload);

export const GetCancellationRefundStatus = async (params: IGetParams): Promise<ISampleResponse> =>
	Get<ISampleResponse>(API_URL.cancellationRefundStatus, params);

export const RetryTransaction = async (params: any): Promise<ISampleResponse> =>
	Get<ISampleResponse>(`${API_URL.retryTransaction}`, params);

export const UpdateMerchantRanking = async (payload: any): Promise<ISampleResponse> =>
	Post<ISampleResponse>(API_URL.updateMerchantRanking, payload);

export const GetMerchantMonthlyLimit = async (): Promise<ISampleResponse> =>
	Get<ISampleResponse>(API_URL.merchantMonthlyLimit);

// export const FetchPendingApplication = async (params: IGetParams): Promise<ISampleResponse> =>
// 	GetStage<ISampleResponse>(`${API_URL.getPendingApplication}`, params);

export const GetMerchantReturnedTerminalsApi = async (): Promise<ISampleResponse> =>
	GetReturn<ISampleResponse>(API_URL.getMerchantReturnedTerminals);

export const FetchInvoiceList = async (params: any): Promise<ISampleResponse> => GetReturn(API_URL.invoiceList, params);

export const CheckBlackListedDocumentApi = async (params: any): Promise<ISampleResponse> =>
	Get(API_URL.checkBlackListDocuments, params);

export const GetKycDocumentsList = async (params: any): Promise<ISampleResponse> =>
	GetAddress(API_URL.getKycDocumentsList, params);

export const DeactivateDeviceApi = async (payload: any): Promise<ISampleResponse> =>
	Post<ISampleResponse>(API_URL.deactivateDevice, payload);

export const DeactivationStatusApi = async (params: any): Promise<ISampleResponse> =>
	GetReturn<ISampleResponse>(API_URL.deactivationStatus, params);

export const CancelDeactivateRequestApi = async (payload: any): Promise<ISampleResponse> =>
	Post<ISampleResponse>(API_URL.deactivationCancel, payload);

export const SaveTermsAndCondition = (payload: any): Promise<ISampleResponse> =>
	Post<ISampleResponse>(apiEnv.SWIPE_BASE_PATH + API_URL.saveTermsAndCondition, payload);

export const GetTermsAndConditionsDetails = async (params: any): Promise<ISampleResponse> =>
	GetReturn<ISampleResponse>(apiEnv.SWIPE_BASE_PATH + API_URL.termsAndConditionsDetails, params);

export const UpdateMerchantProfileParameterApi = async (payload: any): Promise<ISampleResponse> =>
	PostCenter<ISampleResponse>(`${apiEnv.MERCHANT_BASE_PATH_V1}${API_URL.updateMerchantProfileParameter}`, payload);

export const GetMerchantTerminalsApi = async (params: any): Promise<ISampleResponse> =>
	GetReturn<ISampleResponse>(API_URL.getMerchantTerminals, params);

export const ClaimPlanCoupon = async (params: any): Promise<ISampleResponse> =>
	GetReturn<ISampleResponse>(API_URL.claimPlanCoupon, params);

export const FetchIsAllowedToOrder = async (): Promise<ISampleResponse> =>
	GetReturn<ISampleResponse>(apiEnv.SWIPE_BASE_PATH + API_URL.isAllowedToOrder);

export const FetchYearlyCashbackDetails = async (): Promise<IYearlyCashbackApiData> =>
	Get<IYearlyCashbackApiData>(`${apiEnv.SWIPE_BASE_PATH}/${API_URL.getYearlyCashbackDetails}`);

export const FetchIsEligibleForPlanUpgrade = async (): Promise<IYearlyCashbackApiData> =>
	Get<IYearlyCashbackApiData>(`${apiEnv.SWIPE_BASE_PATH}/${API_URL.getIsEligibleForPlanUpgrade}`);

export const GenerateReferralLink = async (params: any): Promise<ISampleResponse> =>
	Get<ISampleResponse>(API_URL.generateReferralLink, { ...params });

export const CheckMerchantReferralAPI = async (payload: any): Promise<ISampleResponse> =>
	Post<ISampleResponse>(API_URL.checkMerchantReferral, payload);

export const FetchSpeakerActiveStatus = async (): Promise<ISampleResponse> =>
	Get<ISampleResponse>(apiEnv.BASE_PATH_SPEAKER + API_URL.getSpeakerActiveStatus);

export const FetchSpeakerAlertPreference = async (): Promise<ISampleResponse> =>
	Get<ISampleResponse>(apiEnv.SWIPE_BASE_PATH + API_URL.getSpeakerAlertPreference);

export const PostSpeakerAlertPreferenceToggle = async (payload: any): Promise<ISampleResponse> =>
	Post<ISampleResponse>(apiEnv.SWIPE_BASE_PATH + API_URL.postSpekerAlertPreferenceToggle, payload);

export const FetchDisputedTxnList = async (params: IGetParams): Promise<ISampleResponse> =>
	GetAddress(`${apiEnv.BASE_SHERLOCK_PATH}/${API_URL.chargebackTxnsList}`, { ...params, sourceProduct });

export const GetChargebackDetails = async (params: IGetParams): Promise<ISampleResponse> =>
	GetAddress(`${apiEnv.BASE_SHERLOCK_PATH}/${API_URL.chargebackDetail}`, params);

export const GetChargebackImageUrl = async (params: IGetParams): Promise<ISampleResponse> =>
	GetAddress(`${apiEnv.BASE_SHERLOCK_PATH}/${API_URL.chargebackGetImageUrl}`, params);

export const UploadChargebackDetails = async (payload: any): Promise<ISampleResponse> =>
	Post<ISampleResponse>(`${apiEnv.BASE_SHERLOCK_PATH}/${API_URL.chargebackUpload}`, payload);

export const ReleaseChargeback = async (payload: IGetParams): Promise<ISampleResponse> =>
	Post(`${apiEnv.BASE_SHERLOCK_PATH}/${API_URL.chargebackRelease}`, payload);

export const GetDisputeTxnsAPI = async (): Promise<ISampleResponse> =>
	Get<ISampleResponse>(`${apiEnv.BASE_SHERLOCK_PATH}/${API_URL.disputeTxns}`, { sourceProduct });

export const SpeakerReturnRequestConsentApi = async (payload: any): Promise<ISampleResponse> =>
	Post<ISampleResponse>(API_URL.speakerReturnRequestConsent, payload);

export const GetMerchantSoundboxDetails = async (): Promise<ISampleResponse> =>
	Get<ISampleResponse>(apiEnv.BASE_PATH_SPEAKER + API_URL.soundbox);

export const GetKycDocsRequestor = async (): Promise<ISampleResponse> => {
	return GetReturn<ISampleResponse>(`${API_URL.kycDocRequestor}`);
};

export const GetSwipeKycDocDetails = async (): Promise<ISampleResponse> => {
	return GetReturn<ISampleResponse>(`${API_URL.swipeKycDocDetails}`);
};

export const GetPaidStatusOrderTracking = async (): Promise<ISampleResponse> => {
	return GetReturn<ISampleResponse>(`${API_URL.paidStatusOrderTracking}`);
};

export const GetServiceRequestList = async (): Promise<ISampleResponse> => {
	return GetReturn<ISampleResponse>(`${API_URL.getServiceRequestList}`);
};

export const GetServiceRequestDetails = async (params: any): Promise<ISampleResponse> => {
	return GetReturn<ISampleResponse>(`${API_URL.getServiceRequestDetails}`, params);
};

export const CreateServiceRequest = async (payload: any): Promise<ISampleResponse> =>
	Post<ISampleResponse>(API_URL.createServiceRequest, payload);

export const GetSwipeOrdersListingAPI = async (params: any): Promise<ISampleResponse> => {
	return GetReturn<ISampleResponse>(`${API_URL.getSwipeOrdersListing}`, params);
};

export const GetSwipeOrdersListingDetailsAPI = async (params: any): Promise<ISampleResponse> => {
	return GetReturn<ISampleResponse>(`${API_URL.getSwipeOrdersListingDetails}`, params);
};

export const GetSwipeOrdersListingReturnDetailsAPI = async (params: any): Promise<ISampleResponse> => {
	return GetReturn<ISampleResponse>(`${API_URL.getSwipeOrdersListingReturnDetails}`, params);
};

export const GetInvoiceThresholdCount = async (params: any): Promise<ISampleResponse> =>
	GetAddress(`${apiEnv.BASE_SHERLOCK_PATH}/${API_URL.invoiceThresholdCount}`, { ...params });

export const GetLaunchLabsConfigApi = async (params: any): Promise<ISampleResponse> => {
	return GetReturn<ISampleResponse>(`${API_URL.getLaunchLabsConfig}`, params);
};
export const PosDeviceDetails = async (payload: any): Promise<ISampleResponse> =>
	Post<ISampleResponse>(API_URL.posDeviceDetails, payload);

export const GetApplicationStatusAPI = async (params: IGetParams): Promise<ISampleResponse> =>
	GetAddress(`${API_URL.applicationStatus}`, params);
export const ChargebackRejectReason = async (params: any): Promise<ISampleResponse> => {
	return GetAddress(`${apiEnv.BASE_SHERLOCK_PATH}/${API_URL.chargebackRejectReasons}`, { ...params });
};

export const CheckMerchantDocumentValidation = async (params: { doc_type: string }): Promise<ISampleResponse> => {
	return GetAddress(`${apiEnv.BASE_SHERLOCK_PATH}/${API_URL.checkMerchantDocumentValidation}`, { ...params });
};

export const ValidateUploadedDocument = async (formData: FormData): Promise<ISampleResponse> => {
	// Use axios directly for multipart/form-data
	const token = loadState(TOKEN_SESSION_KEY, true) || '';
	return fetch(`${apiEnv.BASE_SHERLOCK_PATH}/${API_URL.validateUploadedDocument}`, {
		method: 'POST',
		headers: {
			token: token as string,
		},
		body: formData,
	})
		.then((response) => response.json())
		.then((data) => data)
		.catch((error) => {
			throw error;
		});
};

export const GetMerchantOnboardingStatus = (params: {
	kycRankingRequired?: string;
	product?: string;
}): Promise<INewResponse<any>> => GetAddress(`${apiEnv.MERCHANT_BASE_PATH_V1}/onboarding-status`, params);

export const GetSwipeCpvInfoDetailsAPI = async (params: any): Promise<ISampleResponse> => {
	return GetReturn<ISampleResponse>(`${API_URL.getSwipeCpvInfo}`, params);
};
